import { DispatchStatusEnum } from './@types/enum/dispatchStatusEnum';
import { RightGrantsEnum } from './@types/enum/rightGrantsEnum';
import { TransferRequestStatusEnum } from './@types/enum/transferRequestStatusEnum';
import { TransferTypeEnum } from './@types/enum/transferTypeEnum';

export const ICON_LOCATION = `${ASSET_BASE}/assets/icons`;

export const MAP_CENTER_POSITION : { lat : number; long : number } = {
    lat: -23.5792,
    long: 30.1424,
};

export const IMPORTED_TYPE_INPUT_FIELD = 'Cannot change this input field if this entry is imported.';

export const QUERY_DATA_STALE_TIME = 30 * 60 * 1000;

export const SNACKBAR_WIDTH = 400;

export enum RIGHT_GRANTS {
    View = 0,
    Add = 1,
    Edit = 2,
    Delete = 3,
    Admin = 20,
}

export const RIGHT_LEVELS : Record<string, number> = {
    'View': RIGHT_GRANTS.View,
    'Add': RIGHT_GRANTS.Add,
    'Edit': RIGHT_GRANTS.Edit,
    'Delete': RIGHT_GRANTS.Delete,
    'Admin': RIGHT_GRANTS.Admin,
};

export const RIGHT_GRANT_LEVELS : Record<string, number> = {
    'View': RightGrantsEnum.View,
    'Add': RightGrantsEnum.Add,
    'Edit': RightGrantsEnum.Edit,
    'Delete': RightGrantsEnum.Delete,
    'Admin': RightGrantsEnum.Admin,
};

export const DISPATCH_STATUSES : Record<string, number> = {
    'Draft': DispatchStatusEnum.draft,
    'Instructed': DispatchStatusEnum.instructed,
    'Dispatched': DispatchStatusEnum.dispatched,
};

export const TRANSFER_REQUEST_STATUS : Record<string, number> = {
    'Requested': TransferRequestStatusEnum.requested,
    'Approved': TransferRequestStatusEnum.approved,
    'Rejected': TransferRequestStatusEnum.rejected,
};

export const TRANSFER_TYPE : Record<string, number> = {
    'Intake': TransferTypeEnum.intake,
    'Stock Relocation': TransferTypeEnum.stockRelocation,
    'Stock Transfer': TransferTypeEnum.stockTransfer,
    'Dispatch': TransferTypeEnum.dispatch, // No longer a transfer type
    'Write Off': TransferTypeEnum.writeOff,
};

/* Default rights (Pages accessible to all users) */
export const DEFAULT_RIGHTS = ['/faq'];